<template>
  <el-menu theme="dark"lass="el-menu-demo" mode="horizontal">
  <!-- <el-menu-item v-if="!user.authenticated" index="0"> <router-link to="/"></router-link></el-menu-item> -->
  <!-- <el-menu-item v-if="admin.authenticated" index="1"> <router-link to="/family">Family</router-link></el-menu-item>
  <el-menu-item v-if="admin.authenticated" index="2"> <router-link to="/student">Student</router-link></el-menu-item>
  <el-menu-item v-if="admin.authenticated" index="3"> <router-link to="/classes">Classes</router-link></el-menu-item>
  <el-menu-item v-if="admin.authenticated" index="4"> <router-link to="/payment">Payments</router-link></el-menu-item>
  <el-menu-item v-if="admin.authenticated" index="5"> <router-link to="/payclasses">Paid Classes</router-link></el-menu-item>
  <el-menu-item v-if="admin.authenticated" index="6"> <router-link to="/volunteers">Volunteers</router-link></el-menu-item> -->

   <el-menu-item v-if="teacher.authenticated" index="7"> <router-link to="/attendance">Attendance</router-link></el-menu-item> 
   <el-menu-item v-if=" !teacher.authenticated" index="10"> <router-link to="/teacherlogin">Teacher Login</router-link></el-menu-item> 
   <!-- <el-menu-item v-if="teacher.authenticated" index="11"> <router-link to="/report_attendance">Attendance Report</router-link></el-menu-item>  -->
   <el-menu-item v-if="teacher.authenticated"  @click="logout()"  index="12"> <router-link to="/">Logout</router-link></el-menu-item> 
 

 
 <!--   <el-menu-item v-if="admin.authenticated " index="8"> <router-link to="/teachers">Teachers</router-link></el-menu-item>
   <el-menu-item v-if="!admin.authenticated && !teacher.authenticated && !teacher.attendance" index="9"> <router-link to="/adminlogin">Admin Login</router-link></el-menu-item> 
 -->
<!--  <el-submenu index="2">
    <template slot="title">Workspace</template>
    <el-menu-item index="2-1">item one</el-menu-item>
    <el-menu-item index="2-2">item two</el-menu-item>
    <el-menu-item index="2-3">item three</el-menu-item>
  </el-submenu>
  <el-menu-item index="3">dodo</el-menu-item>-->
</el-menu>
 
</template>
<script>
/*     export default{
        data(){
            return{
                msg: 'Hello vue'
            }
        }
    }
 */
 
  import auth from '../auth'
  // import Volunteers from '../pages/volunteers.vue'

  export default {
    data() {
      return {
        user: auth.user,
        admin: auth.admin,
        teacher: auth.teacher
      }
    },
    methods: {
      logout() {
        auth.logout();
    window.location.reload(true); // logout complete reload login from server. basically start from scratch, lose all user data info.
      this.$router.push({path: '/teacher'});     // physical url must be  /teacher to match exact name.
 
      }
    }
    
  }

 </script>
<style>
    .header{
        width: 100%;
        margin: 0 auto;
    }
    .header img{
        width: 50%;
        margin: 30px auto 0;
        display: block;
    }
</style>



// WEBPACK FOOTER //
// header.vue?4f019a00